import PredictiveSearch from '@shopify/theme-predictive-search';
import * as Helpers from '../utilities/helpers';
Avatar.theme = Avatar.theme || {};

function Search() {
  var _this = this;

  var selectors = {
    searchForm: '[data-search-form]',
    searchInput: '[data-search-input]',
    searchResults: '[data-predictive-search-results]',
    searchResult: '[data-search-result]',
    searchClear: '[data-search-clear]'
  };
  var classes = {
    itemSelected: 'predictive-search-item--selected',
    searchHeader: 'predictive-search__list-header',
    hide: 'tw-hidden'
  };
  this.searchForms = document.querySelectorAll(selectors.searchForm);
  this.searchInputs = document.querySelectorAll(selectors.searchInput);
  this.searchResults = document.querySelectorAll(selectors.searchResults);
  this.searchResult = document.querySelectorAll(selectors.searchResult);
  this.searchClear = document.querySelectorAll(selectors.searchClear);
  var searchConfig = searchConfig || {};
  var isResultVisible = false;
  var allSearchResults;
  var searchKeyword;
  var strings = Avatar.theme.i18n.search;
  var searchSettings = Avatar.theme.settings.search;
  var searchPath = "".concat(Avatar.shop.root !== '/' ? Avatar.shop.root : '', "/search");
  searchConfig.TYPES = ['product'];
  searchSettings.showCollections && searchConfig.TYPES.push('collection');
  searchSettings.showArticles && searchConfig.TYPES.push('article');
  searchSettings.showPages && searchConfig.TYPES.push('page');
  searchConfig.FIELDS = ['title'];
  searchSettings.searchType && searchConfig.FIELDS.push('product_type');
  searchSettings.searchVendor && searchConfig.FIELDS.push('vendor');
  searchSettings.searchTag && searchConfig.FIELDS.push('tag');
  searchSettings.searchSku && searchConfig.FIELDS.push('variants.sku');
  searchSettings.searchVariantTitle && searchConfig.FIELDS.push('variants.title');
  searchSettings.searchBarcode && searchConfig.FIELDS.push('variants.barcode');
  searchSettings.searchDescriptions && searchConfig.FIELDS.push('body');
  searchSettings.searchAuthor && searchConfig.FIELDS.push('author');
  searchConfig.UNAVAILABLE_PRODUCTS = searchSettings.showUnavailableProducts;
  searchConfig.LIMIT = searchSettings.limit;

  var init = function init() {
    if (!canInitializePredictiveSearch()) {
      return;
    }

    addInputEventListeners();

    _addBodyEventListener();

    initPredictiveSearch(searchConfig);
    handleSearch();
  };

  var predictiveSearch = new PredictiveSearch({
    search_path: searchPath,
    resources: {
      type: searchConfig.TYPES.join(','),
      limit: searchConfig.LIMIT,
      options: {
        unavailable_products: searchConfig.UNAVAILABLE_PRODUCTS,
        fields: searchConfig.FIELDS.join(',')
      }
    }
  });

  function isPredictiveSearchSupported() {
    if (Avatar.theme.current.pageType === 'password') return false;
    var shopifyFeatures = JSON.parse(document.getElementById('shopify-features').textContent);
    return shopifyFeatures.predictiveSearch;
  }

  function isPredictiveSearchEnabled() {
    return searchSettings.enabled;
  }

  function canInitializePredictiveSearch() {
    return isPredictiveSearchSupported() && isPredictiveSearchEnabled();
  }

  var handleSearch = function handleSearch() {
    if (_this.searchInputs) {
      _this.searchInputs.forEach(function (input) {
        input.addEventListener('keyup', handleSearchInput);
        input.addEventListener('focusin', handleSearchInput);
      });
    }
  };

  var handleSearchInput = function handleSearchInput(evt) {
    var currentTarget = evt.currentTarget;
    var searchValue = currentTarget.value;
    var isFocus = currentTarget === document.activeElement;
    toggleClearButton(searchValue);
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;
    var RETURN_KEY_CODE = 13;
    var ESCAPE_KEY_CODE = 27;

    if (evt.keyCode === UP_ARROW_KEY_CODE || evt.keyCode === DOWN_ARROW_KEY_CODE || evt.keyCode === RETURN_KEY_CODE || evt.keyCode === ESCAPE_KEY_CODE) {
      evt.preventDefault();

      _handleInputKeyup(evt);

      return false;
    }

    if (searchValue.length > 0 && isFocus) {
      if (searchKeyword !== searchValue) {
        predictiveSearch.query(searchValue);
      }

      showResults();
    } else {
      hideResults();
    }
  };

  var showResults = function showResults() {
    _this.searchResults.forEach(function (results) {
      return results.classList.add('active');
    });

    _this.searchInputs.forEach(function (input) {
      return input.setAttribute('aria-expanded', true);
    });

    isResultVisible = true;
  };

  var hideResults = function hideResults() {
    _this.searchResults.forEach(function (results) {
      return results.classList.remove('active');
    });

    _this.searchInputs.forEach(function (input) {
      return input.setAttribute('aria-expanded', false);
    });

    isResultVisible = false;
  }; // Render Results


  function renderSearchResults(results, query, count) {
    return ['<div class="predictive-search__list p-0 m-0">', '<ul id="predictive-search-results" class="predictive-search__list-wrapper">', renderCollections(results.collections), renderProducts(results.products), renderArticles(results.articles), renderPages(results.pages), '</ul>', renderViewAll(query, count), '</div>'].join('');
  }

  function renderNoResults(results, query, count) {
    return ['<ul id="predictive-search-results" class="predictive-search__list p-0 m-0">', "<li class=\"predictive-search-item predictive-search-item--none text-center p-3\">\n        ".concat(strings.results.none, " &ldquo;").concat(Helpers.htmlEscape(query), "&rdquo;\n      </li>"), renderViewAll(query, count), '</ul>'].join('');
  } // Render Collections


  function renderCollections(collections) {
    if (collections === undefined || !collections.length) {
      return '';
    }

    return ["<li class=\"predictive-search__list-header p-2\">".concat(strings.placeholders.collections, "</li>"), collections.map(function (collection) {
      return renderCollection(collection);
    }).join('')].join('');
  }

  function renderCollection(collection) {
    return "<li class=\"predictive-search-item\" data-search-result>\n              <a href=\"".concat(collection.url, "\" class=\"d-flex align-items-center p-2\">\n                ").concat(renderResultImg(collection.featured_image, 'collection'), "\n                <div class=\"predictive-search-item__content pl-3\">\n                  <span class=\"font-head\">").concat(collection.title, "</span>\n                </div>\n              </a>\n            </li>");
  } // Render Products


  function renderProducts(products) {
    if (products === undefined || !products.length) {
      return '';
    }

    return ["<li class=\"predictive-search__list-header pt-2 mt-2 px-2\">\n       ".concat(strings.placeholders.products, "\n      </li>"), products.map(function (product) {
      return renderProduct(normalizeProduct(product));
    }).join('')].join('');
  }

  function renderProduct(product) {
    return "<li class=\"predictive-search-item\" data-search-result>\n              <a href=\"".concat(product.url, "\" class=\"d-flex align-items-center p-2\">\n                ").concat(renderResultImg(product.image, 'product'), "\n                <div class=\"predictive-search-item__content pl-3\">\n                  <span class=\"font-head\">\n                    ").concat(product.title, "\n                  </span>\n                  ").concat(renderProductDetails(product), "\n                </div>\n              </a>\n            </li>");
  }

  function normalizeProduct(product) {
    var productOrVariant = product.variants.length > 0 ? product.variants[0] : product;
    return {
      url: productOrVariant.url,
      image: getProductImage(product),
      title: product.title,
      vendor: product.vendor || '',
      price: Avatar.theme.Currency.formatMoney(product.price_min),
      compareAtPrice: Avatar.theme.Currency.formatMoney(product.compare_at_price_min),
      available: product.available,
      isOnSale: isOnSale(product),
      isPriceVaries: isPriceVaries(product),
      isCompareVaries: isCompareVaries(product)
    };
  }

  function getProductImage(product) {
    var image;
    var featuredImage;

    if (product.variants.length > 0 && product.variants[0].image !== null) {
      featuredImage = product.variants[0].featured_image;
    } else if (product.image) {
      featuredImage = product.featured_image;
    } else {
      image = null;
    }

    if (image !== null) {
      image = {
        url: featuredImage.url,
        alt: featuredImage.alt
      };
    }

    return image;
  }

  function renderProductDetails(product) {
    return "<dl class=\"predictive-search-item__details\">\n             <div class=\"predictive-search-item__detail predictive-search-item__detail--inline\">\n               ".concat(renderProductPrice(product), "\n             </div>\n           </dl>");
  }

  function isOnSale(product) {
    return product.compare_at_price_min !== null && parseInt(product.compare_at_price_min, 10) > parseInt(product.price_min, 10);
  }

  function isPriceVaries(product) {
    return product.price_max !== product.price_min;
  }

  function isCompareVaries(product) {
    return product.compare_at_price_max !== product.compare_at_price_min;
  }

  function renderProductPrice(product) {
    var priceMarkup = "<div class=\"price__regular\">".concat(renderPrice(product), "</div>");
    var salePriceMarkup = "<div class=\"price__sale d-flex align-items-baseline\">".concat(renderSalePrice(product), "</div>");
    return "<div class=\"price__pricing-group font-600\">\n              ".concat(product.isOnSale ? salePriceMarkup : priceMarkup, "\n            </div>");
  }

  function renderSalePrice(product) {
    return ['<dt>', "<span class=\"sr-only\">".concat(Avatar.theme.i18n.salePrice, "</span>"), '</dt>', '<dd>', "<span class=\"sale tw-text-price font-body\">\n      ".concat(product.isPriceVaries ? strings.fromLowestPrice.replace('[price]', product.price) : product.price, "\n        </span>"), '</dd>', renderCompareAtPrice(product)].join('');
  }

  function renderCompareAtPrice(product) {
    return ['<dt>', "<span class=\"sr-only\">".concat(Avatar.theme.i18n.regularPrice, "</span> "), '</dt>', '<dd>', "<s class=\"compare ml-1 tw-text-price-sale font-body\">\n        ".concat(product.compareAtPrice, "\n      </s>"), '</dd>'].join('');
  }

  function renderPrice(product) {
    return ['<dt>', "<span class=\"sr-only\">".concat(Avatar.theme.i18n.regularPrice, "</span>"), '</dt>', '<dd>', "<span class=\"regular font-body\">\n        ".concat(product.isPriceVaries ? strings.fromLowestPrice.replace('[price]', product.price) : product.price, "\n      </span>"), '</dd>'].join('');
  } // Render Pages


  function renderPages(pages) {
    if (pages === undefined || !pages.length) {
      return '';
    }

    return ["<li class=\"predictive-search__list-header pt-2 mt-2 px-2\">\n        ".concat(strings.placeholders.pages, "\n      </li>"), pages.map(function (page) {
      return renderPage(page);
    }).join('')].join('');
  }

  function renderPage(page) {
    return "<li class=\"predictive-search-item \" data-search-result>\n              <a href=\"".concat(page.url, "\" class=\"d-flex align-items-center p-2\">\n                ").concat(renderFallbackImg('page'), "\n                <div class=\"predictive-search-item__content pl-3 font-head\">\n                  ").concat(page.title, "\n                </div>\n              </a>\n            </li>");
  } // Render Articles


  function renderArticles(articles) {
    if (articles === undefined || !articles.length) {
      return '';
    }

    return ["<li class=\"predictive-search__list-header pt-2 mt-2 px-2\">\n        ".concat(strings.placeholders.articles, "\n      </li>"), articles.map(function (article) {
      return renderArticle(article);
    }).join('')].join('');
  }

  function renderArticle(article) {
    return "<li class=\"predictive-search-item\" data-search-result>\n              <a href=\"".concat(article.url, "\" class=\"d-flex align-items-center p-2\">\n                ").concat(renderResultImg(article.featured_image, 'article'), "\n                <div class=\"predictive-search-item__content pl-3 font-head\">\n                  ").concat(article.title, "\n                </div>\n              </a>\n            </li>");
  } // Render Images


  function renderResultImg(image, type) {
    if (image !== null && image.url !== null) {
      return "<img class=\"predictive-search-item__image lazyload\" data-src=\"".concat(Shopify.theme.ThemeImages.getSizedImageUrl(image.url, '120x'), "\" alt=\"").concat(image.alt, "\" data-image-loading-placeholder/>");
    }

    return renderFallbackImg(type);
  }

  function renderFallbackImg(type) {
    var icon;

    switch (type) {
      case 'collection':
        icon = Avatar.icons.collection;
        break;

      case 'product':
        icon = Avatar.icons.product;
        break;

      case 'page':
        icon = Avatar.icons.page;
        break;

      case 'article':
        icon = Avatar.icons.article;
        break;

      default:
        icon = Avatar.icons.product;
        break;
    }

    return "<img class=\"predictive-search-item__image lazyload\" src=\"".concat(icon, "\" alt=\"").concat(type, "\"/>");
  } // Render View All


  function renderViewAll(query, count) {
    if (count === 0) {
      return '';
    }

    return "<div class=\"predictive-search-item predictive-search-view-all\" data-search-result>\n              <button\n                class=\"predictive-search-view-all__button py-2 tw-font-semibold\"\n                type=\"submit\">\n                ".concat(strings.results.show, " &ldquo;").concat(Helpers.htmlEscape(query), "&rdquo;\n              </button>\n            </div>");
  } // Initialize


  var initPredictiveSearch = function initPredictiveSearch() {
    predictiveSearch.on('success', function (json) {
      var results = json.resources.results;
      var query = json.query;
      var collections = results.collections,
          products = results.products,
          articles = results.articles,
          pages = results.pages;
      var resultsArray = [];
      collections && resultsArray.push(collections);
      products && resultsArray.push(products);
      articles && resultsArray.push(articles);
      pages && resultsArray.push(pages);
      var resultsCount = resultsArray.flat().length;
      var resultsHtml;

      if (resultsCount > 0) {
        resultsHtml = renderSearchResults(results, query, resultsCount);
        allSearchResults = resultsArray;
        searchKeyword = query;
      } else {
        resultsHtml = renderNoResults(results, query, resultsCount);
        allSearchResults = null;
      }

      _this.searchResults.forEach(function (container) {
        // eslint-disable-next-line no-param-reassign
        container.innerHTML = resultsHtml;
      });
    });
    predictiveSearch.on('error', function (error) {
      console.log(error);
    });
  }; // Helpers


  var addInputEventListeners = function addInputEventListeners() {
    if (!_this.searchInputs) {
      return;
    } // input.addEventListener("focus", this._handleInputFocus);
    // input.addEventListener("blur", this._handleInputBlur);
    // input.on("keyup", _handleInputKeyup);
    // form.on('submit', _handleFormSubmit);


    _this.searchInputs.forEach(function (input) {
      return input.addEventListener('keydown', _handleInputKeydown);
    });

    _this.searchClear.forEach(function (clear) {
      return clear.addEventListener('click', _handleClearSearch.bind(_this));
    }); // input.on('keydown', _handleInputKeydown);
    // if (reset) {
    //   this._handleInputReset = this._handleInputReset.bind(this);
    //   reset.addEventListener("click", this._handleInputReset);
    // }

  };

  function _handleInputKeydown(evt) {
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;
    var RETURN_KEY_CODE = 13; // Prevent the cursor from moving in the input when using the up and down arrow keys

    if (evt.keyCode === UP_ARROW_KEY_CODE || evt.keyCode === DOWN_ARROW_KEY_CODE || evt.keyCode === RETURN_KEY_CODE) {
      evt.preventDefault();
    }
  }

  function _handleInputKeyup(evt) {
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;
    var RETURN_KEY_CODE = 13;
    var ESCAPE_KEY_CODE = 27;
    var BACKSPACE = 8;

    if (isResultVisible && allSearchResults !== null) {
      if (evt.keyCode === UP_ARROW_KEY_CODE) {
        _navigateOption(evt, 'UP');

        return true;
      }

      if (evt.keyCode === DOWN_ARROW_KEY_CODE) {
        _navigateOption(evt, 'DOWN');

        return true;
      }

      if (evt.keyCode === RETURN_KEY_CODE) {
        _selectOption();

        return true;
      }
    }

    if (evt.keyCode === ESCAPE_KEY_CODE) {
      resetSearch();
    }

    if (BACKSPACE === 8 && evt.target.value.length <= 0) {
      hideResults();
    }

    return true;
  }

  function _getSelectedOption() {
    var results = document.querySelector(selectors.searchResults);
    return results.querySelector(".".concat(classes.itemSelected));
  }

  var _selectOption = function _selectOption() {
    var selectedOption = _getSelectedOption();

    if (selectedOption) {
      selectedOption.querySelector('a, button').click();
    } // Let returns still submit form


    if (selectedOption === null && searchKeyword.length !== 0) {
      var searchForm = _this.searchForms[0];
      var searchInput = searchForm.querySelector(selectors.searchInput);
      var submitValue = searchKeyword;
      searchInput.value = submitValue;
      searchForm.submit();
    }
  };

  function _handleClearSearch(evt) {
    evt.preventDefault();
    resetSearch();
  }

  var resetSearch = function resetSearch() {
    _this.searchInputs.forEach(function (input) {
      // eslint-disable-next-line no-param-reassign
      input.value = '';
    });

    var searchList = document.querySelectorAll('.predictive-search__list');
    searchList.forEach(function (list) {
      return list.remove();
    });
    searchKeyword = '';
    hideResults();
    toggleClearButton(searchKeyword);
  };

  var toggleClearButton = function toggleClearButton(value) {
    if (value.length > 0) {
      _this.searchClear.forEach(function (clear) {
        clear.classList.remove(classes.hide);
      });
    } else {
      _this.searchClear.forEach(function (clear) {
        clear.classList.add(classes.hide);
      });
    }
  };

  function _navigateOption(evt, direction) {
    var results = document.querySelector(selectors.searchResults);

    var currentOption = _getSelectedOption();

    if (!currentOption) {
      var firstOption = results.querySelector(selectors.searchResult);
      firstOption.classList.add(classes.itemSelected); // this._updateAccessibilityAttributesAfterSelectingElement(null, firstOption);
    } else if (direction === 'DOWN') {
      var nextOption = currentOption.nextElementSibling;

      if (nextOption && nextOption.classList.contains(classes.searchHeader)) {
        nextOption = currentOption.nextElementSibling.nextElementSibling;
      }

      if (nextOption) {
        currentOption.classList.remove(classes.itemSelected);
        nextOption.classList.add(classes.itemSelected); // this._updateAccessibilityAttributesAfterSelectingElement(
        //   currentOption,
        //   nextOption
        // );
      }
    } else {
      var previousOption = currentOption.previousElementSibling;

      if (previousOption.classList.contains(classes.searchHeader)) {
        previousOption = currentOption.previousElementSibling.previousElementSibling;
      }

      if (previousOption) {
        currentOption.classList.remove(classes.itemSelected);
        previousOption.classList.add(classes.itemSelected); // this._updateAccessibilityAttributesAfterSelectingElement(
        //   currentOption,
        //   previousOption
        // );
      }
    }
  } // function _handleFormSubmit(evt) {
  //   if (_getSelectedOption() != null) {
  //     evt.preventDefault();
  //     _selectOption();
  //     return true;
  //   }
  // }


  function _addBodyEventListener() {
    document.querySelector('body').addEventListener('mousedown', _handleBodyMousedown);
  }

  function _handleBodyMousedown(evt) {
    if (isResultVisible && allSearchResults !== null) {
      if (evt.target.isEqualNode(document.querySelector(selectors.searchInput)) || evt.target.closest(selectors.searchResults) || evt.target.closest(selectors.searchResult) || evt.target.closest(selectors.searchForm)) {
        return false;
      }

      hideResults();
    }
  }

  function _removeBodyEventListener() {
    document.querySelector('body').removeEventListener('mousedown', _handleBodyMousedown);
  }

  var removeInputEventListeners = function removeInputEventListeners() {
    if (!_this.searchInputs) {
      return;
    }

    _this.searchInputs.forEach(function (input) {
      input.removeEventListener('keydown', _handleInputKeydown);
      input.removeEventListener('keyup', handleSearchInput);
      input.removeEventListener('focusin', handleSearchInput);
    });

    _this.searchClear.forEach(function (clear) {
      return clear.addEventListener('click', _handleClearSearch);
    });
  };

  function destroy() {
    hideResults();

    _removeBodyEventListener();

    removeInputEventListeners();
  }

  init();
  return {
    init: init,
    initPredictiveSearch: initPredictiveSearch,
    destroy: destroy
  };
}

Avatar.theme.PredictiveSearch = new Search();